
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casinos/[id]/slot-reviews",
      function () {
        return require("private-next-pages/casinos/[id]/slot-reviews/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casinos/[id]/slot-reviews"])
      });
    }
  